import React from 'react';
import { func, number, string, shape, arrayOf } from 'prop-types';

import withSpinner from '~components/Spinner';

import Result from './components/Result';

function Results({ results, maxResults, onResultSelect }) {
  return (
    <>
      <Result onClick={onResultSelect} />
      {results.map(
        (result, i) =>
          i < maxResults && (
            <Result data={result} key={result.id || result.placeId} onClick={onResultSelect} />
          )
      )}
    </>
  );
}

Results.propTypes = {
  results: arrayOf(
    shape({
      placeId: string,
      description: string
    })
  ).isRequired,
  onResultSelect: func.isRequired,
  maxResults: number
};

export default withSpinner({ WrappedComponent: Results });
